import { LIVE_LIST_NAMES } from '../apis';
import { LiveListOption } from '../apis/hooks/models/liveListOption';

/**
 * Maps a Live List payload into normalized Plant options.
 * Ensures option `value` is always a string for stable filter payloads.
 *
 * @param {{ items?: Array<{ label?: string, value?: string|number, metadata?: any, disabled?: boolean }> }|null|undefined} data
 * @returns {LiveListOption[]}
 */
const toPlantOptions = (data) => {
	const rawOptions = Array.isArray(data?.items) ? data.items : [];
	return rawOptions.map(
		(option) =>
			new LiveListOption({
				...option,
				value: String(option?.value ?? ''),
				label: option?.label || '',
			})
	);
};

/**
 * Fetches Plants live list and returns the original response plus
 * a normalized `options` array for UI consumption.
 *
 * @param {(request: { listName: string, filters?: any }) => Promise<any>} getLiveList
 * @returns {Promise<any & { options: LiveListOption[] }>}
 */
export const fetchPlants = async (getLiveList) => {
	const response = await getLiveList({
		listName: LIVE_LIST_NAMES.PLANTS,
	});

	if (response?.isAborted || response?.isError) {
		return {
			...response,
			options: [],
		};
	}

	return {
		...response,
		options: toPlantOptions(response?.data),
	};
};
